'use client';

import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import sanitizeHtml from 'sanitize-html';
import BioCard from '../shared/BioCard';

const sanitizeAndRenderHtml = (
  content: string | undefined
): { __html: string } | undefined => {
  if (!content) return undefined;

  const sanitized = sanitizeHtml(content, {
    allowedAttributes: {
      span: ['class'],
    },
    allowedClasses: {
      span: ['*'], // Allow all classes on span elements
    },
    allowedTags: ['b', 'strong', 'i', 'em', 'u', 'span', 'br', 'p'],
  });

  return { __html: sanitized };
};

type FounderType = 'Serina' | 'Ella' | undefined;

interface FounderBioSectionProps {
  founders?: Array<{
    bio: string;
    cardKey: string;
    name: string;
    theme: 'serina' | 'ella';
    title: string;
  }>;
}

export default function FounderBioSection({
  founders = [],
}: FounderBioSectionProps) {
  const [founder, setFounder] = React.useState<FounderType>(undefined);

  return (
    <section className="flex w-full flex-col items-center py-[48px] md:py-[24px]">
      <div className="content-wrapper">
        <motion.div
          layout
          className="md:align-center z-20 flex w-full flex-col gap-5 md:max-h-[1150px] md:flex-row md:justify-center"
          data-component-name="AboutUsPage-BioCards-Container"
        >
          <AnimatePresence>
            {founders.map(founderData => (
              <BioCard
                key={founderData.cardKey}
                name={founderData.name}
                title={founderData.title}
                bio={
                  <span
                    dangerouslySetInnerHTML={sanitizeAndRenderHtml(
                      founderData.bio
                    )}
                  />
                }
                cardKey={founderData.cardKey}
                currentCard={founder}
                onToggle={(card: string | undefined) =>
                  setFounder(card as FounderType)
                }
                theme={founderData.theme}
              />
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
}
